import AppointmentRequest from './AppointmentRequest.js';

export default AppointmentRequest;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/AppointmentRequest/index.js